import {
  getFeedCategories,
  getFeedProviders,
  getGamesFeed
} from '@namespace/games';
import { parseVsGamesPlex } from './normalize/normalizePlex';
import { parseVsGamesFeed } from './normalize';
import { useVirtualSportsStore } from './store';

export const actionsCreator = ({ setState, getState }) => ({
  GET_VIRTUAL_SPORTS_FEED: async ({ platform, feedName, userSegments }) => {
    try {
      const data = await getGamesFeed({
        feedNames: feedName,
        platform,
        userSegments
      });
      const parsedFeed = parseVsGamesFeed({ data, feedName });
      const state = getState();

      setState({
        feed: {
          ...state.feed,
          ...parsedFeed,
          feedName,
          platform,
          isLoaded: true,
          isLoading: false
        }
      });
    } catch (e) {
      console.error(e);
    }
  },
  // new plex-api
  GET_VIRTUAL_SPORTS_FEED_PLEX: async ({
    platform,
    feedName,
    userSegments,
    lang,
    filter
  }) => {
    try {
      const [categoriesData, providersData] = await Promise.all([
        getFeedCategories({
          platform,
          lang,
          feedName,
          filter,
          userSegments
        }),
        getFeedProviders({
          platform,
          lang,
          feedName,
          filter,
          userSegments
        })
      ]);

      const parsedFeed = parseVsGamesPlex({
        categoriesData,
        providersData,
        feedName
      });

      const state = getState();

      setState({
        feed: {
          ...state.feed,
          ...parsedFeed,
          feedName,
          platform,
          isLoaded: true,
          isLoading: false
        },
        isLoaded: true
      });
    } catch (e) {
      console.error(e);
    }
  },
  // end of new plex api
  SET_IS_VIRTUAL_SPORTS_FEED_LOADING: (isLoading) => {
    const state = getState();

    setState({
      feed: {
        ...state.feed,
        isLoading
      }
    });
  }
});

export const virtualSportsActions = actionsCreator(useVirtualSportsStore);
